export default __webpack_public_path__ + "static/media/12.4e912528.jpg";